<template>
  <div>
    <h2 style="margin-bottom: 8px; font-weight: 600;"><span class="mdi mdi-email" style="margin-right: 8px;"></span>SMS送付</h2>
    <div style="display: flex; align-items: center; margin-bottom: 8px;">
      <p style="text-align: left; font-size: smaller; width: 150px;"><span class="mdi mdi-note-text" style="margin-right: 8px;"></span>SMSテンプレート</p>
      <select v-model="templateIndex" class="select is-small" style="width: calc(100% - 176px); margin-right: 8px;">
        <option :value="i" v-for="(t, i) in SMSTemplates" :key="i + '-template'" v-if="t.is_SMS">
          {{t.name}}
        </option>
      </select>
    </div>

    <div v-if="!bulk" style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600;">
      <p style="margin-right: 4px; font-size: smaller; width: 80px; text-align: left;">TO:</p>
      <input disabled="True" class="input is-small" v-model="sendSMSTemplate.to_email"/>
    </div>
    <div v-else style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600; font-size: smaller;">
      <p style="margin-right: 4px; font-size: smaller; width: 80px; text-align: left;">TO:</p><span>チェック済みのユーザー全員に送付します。</span>
    </div>
    <textarea class="textarea input disp-scroll" maxlength="670" v-model="sendSMSTemplate.template" ref="quillEditor" :options="options" v-if="SMSTemplates.length > 0" @input="onInputChange"></textarea>
    <button
      v-if="isSaveButton"
      @click="tempSaveSMS(bulk)"
      class="button is-small is-fullwidth"
      style="margin: 8px;">
      <span class="mdi" style="margin-right: 8px;"></span>一時保存する
    </button>
    <button @click="sendSMSToSeeker(date)"
      class="button is-primary is-small is-fullwidth"
      :class="{'is-loading': sendLoadding}"
      style="margin-top: 8px;">
      <span class="mdi mdi-email" style="margin-right: 8px;"></span>SMSを送る
    </button>
    <template v-if="isLinkMenu">
      <div style="display: flex; align-items: center; margin-top: 8px;">
        <p style="text-align: left; font-size: smaller; width: 150px;"><span class="mdi mdi-robot" style="margin-right: 8px;"></span>ロボリンク</p>
        <select v-model="sendSMSTemplate.robo" class="select is-small" style="width: calc(100% - 176px); margin-right: 8px;">
          <template v-for="(c, i) in isConfirmChatbot(chatbots)">
            <option :key="i + '-tempbot'" :value="c.bot_id" v-if="!c.is_archive">
              {{c.name}}
            </option>
          </template>
        </select>
        <button class="button is-small" style="border-radius: 4px;" @click="helpMessage('__robo_url__とメール本文に挿入することで自動的に設定されたロボのリンクが作成されます。')">
          <span class="mdi mdi-help-circle-outline"></span>
        </button>
      </div>
      <div style="display: flex; align-items: center; margin-top: 8px;">
        <p style="text-align: left; font-size: smaller; width: 150px;"><span class="mdi mdi-message-video" style="margin-right: 8px;"></span>Web会議リンク</p>
        <select v-model="sendSMSTemplate.video_user" class="select is-small" style="width: calc(100% - 176px); margin-right: 8px;">
          <template v-for="(u, i) in showUsers">
            <option :key="i + '-tempuser'" :value="u.user_hash">
              {{u.username}}
            </option>
          </template>
        </select>
        <button class="button is-small" style="border-radius: 4px;" @click="helpMessage('__video_url__とメール本文に挿入することで自動的に設定されたWeb会議のリンクが作成されます。')">
          <span class="mdi mdi-help-circle-outline"></span>
        </button>
      </div>
      <div style="display: flex; align-items: center; margin-top: 8px;">
        <p style="text-align: left; font-size: smaller; width: 150px;"><span class="mdi mdi-file-video" style="margin-right: 8px;"></span>録画面接リンク</p>
        <select v-model="sendSMSTemplate.record" class="select is-small" style="width: calc(100% - 176px); margin-right: 8px;">
          <template v-for="(r, i) in recordingInterviews">
            <option :key="i + '-temprecord'" :value="r.id">
              {{r.name}}
            </option>
          </template>
        </select>
        <button class="button is-small" style="border-radius: 4px;" @click="helpMessage('__record_url__とメール本文に挿入することで自動的に設定された録画面接のリンクが作成されます。')">
          <span class="mdi mdi-help-circle-outline"></span>
        </button>
      </div>
    </template>
    <!-- 置換説明の表示切り替え -->
    <div v-if="isReplaceExplanation">
      <template>
        <div class="desc">
          <p class="comment">(※1) 送付内容は670文字以内でお願いいたします。</p>
          <p class="comment">(※2) SMSの送付元が表示されないため、本文中に企業名の入力をお願いいたします。</p>
          <p class="comment">(※3) <span style="font-weight: bold">__applicant__</span>と入力すると訪問者のお名前に沿って変換されます。</p>
          <p class="comment">(※4) <span style="font-weight: bold">__date_modify__</span>とメール内容に入力すると日程自動調整で設定されていた場合に訪問者向け日程変更リンクに変換されます。</p>
          <p class="comment">(※5) ロボリンクに指定したロボにミニロボが設定されている場合、応募者のカスタムカラムにミニロボ名が設定されている場合にのみ、変換が可能です。</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpenSMSMenu: {
      type: Boolean,
      default: true,
      required: false
    },
    bulk: {
      type: Boolean,
      required: true
    },
    chatbots: {
      type: Array,
      required: true
    },
    recordingInterviews: {
      type: Array,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    sendLoadding: {
      type: Boolean,
      required: true
    },
    SMSTemplates: {
      type: Array,
      required: true
    },
    sendSMSTemplate: {
      type: Object,
      required: false
    },
    changeSMSTemplate: {
      type: Function,
      required: true
    },
    sendSMSToSeeker: {
      type: Function,
      required: true
    },
    copyLink: {
      type: Function,
      required: true
    },
    tempSaveSMS: {
      type: Function,
      required: true
    },
    helpMessage: {
      type: Function,
      required: true
    },
    isSaveButton: {
      type: Boolean,
      default: true,
      required: false
    },
    isLinkMenu: {
      type: Boolean,
      default: false,
      required: false
    },
    date: {
      type: Object,
      default: null,
      required: false
    },
    isReplaceExplanation: {
      type: Boolean,
      default: false,
      required: false
    },
  },
  data() {
    return {
      templateIndex: 0,
      isEditing: false  // 編集中かどうかを追跡する変数を追加
    };
  },
  watch: {
    isOpenSMSMenu() {
      if (this.isOpenSMSMenu === false) {
        this.templateIndex = 0
        this.isEditing = false
        this.$emit('update:editing', false)
      }
    },
    templateIndex() {
      if (this.isOpenSMSMenu === true) {
        this.changeSMSTemplate(this.templateIndex)
        // テンプレート選択時は編集状態にしない
        this.isEditing = false
        this.$emit('update:editing', false)
      }
    }
  },
  computed: {
    showUsers () {
        // ログイン不可ユーザーを表示しない
        return this.users.filter(user => {return user.permission < 3})
    },
  },
  methods: {
    // 編集状態を設定するメソッド
    setEditing(isEditing) {
      if (this.isEditing !== isEditing) {
        this.isEditing = isEditing
        this.$emit('update:editing', isEditing)
      }
    },
    // フォーム変更時の処理
    onInputChange() {
      this.setEditing(true)
    },
    isConfirmChatbot (chatbots) {
      let confirmChatbots = []
      for (const c of chatbots) {
        if (c.is_confirm) {
          confirmChatbots.push(c)
        }
      }
      return confirmChatbots
    }
  }
};
</script>

<style scoped lang="scss">
.desc {
  margin-top: 16px;
  p {
    font-size: 14px;
    color: gray;
  }
}
.comment {
  text-align: left;
  color: grey;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/emails/SMSActionContent.vue